import actions from './actions';

const initState = {
  isSearching: false,
  isCreating: false,
  isUpdating: false,
  isDeleting: false,
};

export default function reducer(state = initState, action) {
  switch (action.type) {
    case actions.CREATE_MEMBER_POINT_TYPE:
    case action.CREATE_MEMBER_POINT_ALLOCATION_RULE:
    case action.CREATE_MEMBER_POINT_DEDUCTION_RULE:
    case action.CREATE_MEMBER_POINT_EXCHANGE:
      return {
        ...state,
        isCreating: true,
      };
    case actions.CREATE_MEMBER_POINT_TYPE_ENDED:
    case actions.CREATE_MEMBER_POINT_ALLOCATION_RULE_ENDED:
    case actions.CREATE_MEMBER_POINT_DEDUCTION_RULE_ENDED:
    case actions.CREATE_MEMBER_POINT_EXCHANGE_ENDED:
      return {
        ...state,
        isCreating: false,
      };
    case actions.SEARCH_MEMBER_POINT_TYPES:
    case actions.SEARCH_MEMBER_POINT_ALLOCATION_RULES:
    case actions.SEARCH_MEMBER_POINT_DEDUCTION_RULES:
    case actions.SEARCH_MEMBER_POINT_TRANSACTION_RECORDS:
    case actions.GET_ENABLED_MEMBER_POINT_TYPES:
    case actions.FIND_MEMBER_POINT_ALLOCATION_RULE:
    case actions.SEARCH_MEMBER_POINT_EXCHANGE:
      return {
        ...state,
        isSearching: true,
      };
    case actions.SEARCH_MEMBER_POINT_TYPES_ENDED:
    case actions.SEARCH_MEMBER_POINT_ALLOCATION_RULES_ENDED:
    case actions.SEARCH_MEMBER_POINT_DEDUCTION_RULES_ENDED:
    case actions.SEARCH_MEMBER_POINT_TRANSACTION_RECORDS_ENDED:
    case actions.FIND_MEMBER_POINT_ALLOCATION_RULE_ENDED:
    case actions.SEARCH_MEMBER_POINT_EXCHANGE_ENDED:
      return {
        ...state,
        isSearching: false,
      };
    case actions.GET_ENABLED_MEMBER_POINT_TYPES_ENDED:
      return {
        ...state,
        pointTypes: action.pointTypes || [],
        isSearching: false,
      };
    case actions.UPDATE_MEMBER_POINT_TYPE:
    case actions.UPADTE_MEMBER_POINT_ALLOCATION_RULE:
    case actions.UPDATE_MEMBER_POINT_DEDUCTION_RULE:
    case actions.UPDATE_MEMBER_POINT_EXCHANGE:
      return {
        ...state,
        isUpdating: true,
      };
    case actions.UPDATE_MEMBER_POINT_TYPE_ENDED:
    case actions.UPADTE_MEMBER_POINT_ALLOCATION_RULE_ENDED:
    case actions.UPDATE_MEMBER_POINT_DEDUCTION_RULE_ENDED:
    case actions.UPDATE_MEMBER_POINT_EXCHANGE_ENDED:
      return {
        ...state,
        isUpdating: false,
      };
    case actions.DELETE_MEMBER_POINT_TYPES:
    case actions.DELETE_MEMBER_POINT_ALLOCATION_RULES:
    case actions.DELETE_MEMBER_POINT_DEDUCTION_RULES:
    case actions.DELETE_MEMBER_POINT_EXCHANGE:
      return {
        ...state,
        isDeleting: true,
      };
    case actions.DELETE_MEMBER_POINT_TYPES_ENDED:
    case actions.DELETE_MEMBER_POINT_ALLOCATION_RULES_ENDED:
    case actions.DELETE_MEMBER_POINT_DEDUCTION_RULES_ENDED:
    case actions.DELETE_MEMBER_POINT_EXCHANGE_ENDED:
      return {
        ...state,
        isDeleting: false,
      };
    default:
      return state;
  }
}
